import { jsx as _jsx } from "react/jsx-runtime";
import Svg from '../../Svg';
const BluebeamBBrand = ({ size, ...rest }) => {
    return (_jsx(Svg, { size: size, viewBox: "0 0 32 32", ...rest, children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.9912 20.988V11.9912H20.9824V20.9824H11.9912V20.988ZM11.9912 3V7.49559H25.478V25.478H7.49559V3H3V29.9792H29.9792V3H11.9912Z", fill: "#0074CC" }) }));
};
export default BluebeamBBrand;
//# sourceMappingURL=BluebeamBBrand.js.map